var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg052Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 3H12.9999C12.4476 3 11.9999 3.44772 11.9999 4C11.9999 4.55228 12.4476 5 12.9999 5H17.5899L11.4699 11.11C8.92696 9.30507 5.42527 9.749 3.41318 12.1314C1.40109 14.5138 1.54942 18.0404 3.75446 20.2455C5.95949 22.4505 9.48609 22.5988 11.8685 20.5867C14.2509 18.5746 14.6948 15.073 12.8899 12.53L18.9999 6.41V11C18.9999 11.5523 19.4476 12 19.9999 12C20.5522 12 20.9999 11.5523 20.9999 11V4C20.9999 3.44772 20.5522 3 19.9999 3ZM7.99991 20C5.79077 20 3.99991 18.2091 3.99991 16C3.99991 13.7909 5.79077 12 7.99991 12C10.209 12 11.9999 13.7909 11.9999 16C11.9999 17.0609 11.5785 18.0783 10.8283 18.8284C10.0782 19.5786 9.06077 20 7.99991 20Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg052Male);
export default __webpack_public_path__ + "static/media/052-male.3797d2fab158c15e9770d2a276d9d1ac.svg";
export { ForwardRef as ReactComponent };